import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    LoginSplitScreenComponent,
    PropertySnapshotAnalysisComponent,
    PublicPageShellComponent,
    VestaAvatarComponent,
    VestaTabsComponent,
    ZillowBoxComponent,
    VestaInfoComponent,
    DashboardSidemenuComponent,
    PropertyProgressTrackerComponent,
    CalculatorBoxComponent
} from './components';
import { LoginModalComponent } from './modals/login-modal/login-modal.component';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { InfoModalComponent } from './modals/info-modal/info-modal.component';
import { MinuteSecondsPipe } from './pipes/minute-seconds.pipe';
import {
    PhoneMaskDirective,
    CopyToClipboardDirective,
    PropertyAutocompleteDirective
} from './directives';
import { ReplaceUnderscorePipe } from './pipes/replace-underscore.pipe';
import { HideInfinityPipe } from './pipes/hide-infinity.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    RehabCalculatorBoxComponent
} from './pages/organization/dashboard/properties/property/property-rehab-calculator/rehab-calculator-box/rehab-calculator-box.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { VestaRootShellComponent } from './components/vesta-root-shell/vesta-root-shell.component';
import { LandingSidemenuComponent } from './components/landing-sidemenu/landing-sidemenu.component';
import { PropertySidemenuComponent } from './components/property-sidemenu/property-sidemenu.component';
import { AppStoreComponent } from './pages/app-store/app-store.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NbLayoutModule, NbThemeModule } from '@nebular/theme';
import { HttpClientModule } from '@angular/common/http';
import { ChatSidemenuComponent } from './components/chat-sidemenu/chat-sidemenu.component';
import { ChatSidemenuModule } from './components/chat-sidemenu/chat-sidemenu.component.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatExpansionModule,
        MatTooltipModule,
        MatSnackBarModule,
        NbLayoutModule,
        NbThemeModule.forRoot({ name: 'default' }),
        ChatSidemenuModule
    ],
    declarations: [
        // components
        AppStoreComponent,
        LoginSplitScreenComponent,
        PropertySnapshotAnalysisComponent,
        PublicPageShellComponent,
        VestaAvatarComponent,
        ZillowBoxComponent,
        VestaInfoComponent,
        VestaTabsComponent,
        DashboardSidemenuComponent,
        PropertyProgressTrackerComponent,
        CalculatorBoxComponent,
        RehabCalculatorBoxComponent,
        VestaRootShellComponent,
        LandingSidemenuComponent,
        PropertySidemenuComponent,

        // modals
        LoginModalComponent,
        InfoModalComponent,

        // pipes
        PhoneNumberPipe,
        MinuteSecondsPipe,
        ReplaceUnderscorePipe,
        HideInfinityPipe,

        // directives
        PhoneMaskDirective,
        CopyToClipboardDirective,
        PropertyAutocompleteDirective
    ],
    exports: [
        // components
        LoginSplitScreenComponent,
        PropertySnapshotAnalysisComponent,
        PublicPageShellComponent,
        VestaAvatarComponent,
        ZillowBoxComponent,
        VestaInfoComponent,
        VestaTabsComponent,
        DashboardSidemenuComponent,
        PropertyProgressTrackerComponent,
        CalculatorBoxComponent,
        RehabCalculatorBoxComponent,
        VestaRootShellComponent,
        LandingSidemenuComponent,
        PropertySidemenuComponent,
        ChatSidemenuComponent,

        // modals
        LoginModalComponent,
        InfoModalComponent,

        // pipes
        PhoneNumberPipe,
        MinuteSecondsPipe,
        ReplaceUnderscorePipe,
        HideInfinityPipe,

        // directives
        PhoneMaskDirective,
        CopyToClipboardDirective,
        PropertyAutocompleteDirective
    ],
    providers: [
        PhoneNumberPipe,
        HideInfinityPipe
    ]
})
export class SharedModule {
}
